"use client";

import { BotMessageSquare } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import { cn, formatDate } from "@/lib/utils";

interface Props {
    text: string;
    date: Date;
    className?: string;
}

const CorrectionMessage: React.FC<Props> = ({ text, date, className }) => {
    const [enableEdit, setEnableEdit] = React.useState(false);
    const [value, setValue] = React.useState(text);

    const toggleEdit = () => {
        setEnableEdit((prev) => !prev);
    };

    return (
        <div className={cn("rounded-lg border p-4 text-gray-600", className)}>
            <div className="flex items-start gap-4">
                <div className="flex size-10 items-center justify-center rounded-full bg-blue-100 p-2">
                    <BotMessageSquare className="size-6 text-blue-600" />
                </div>
                {enableEdit ? <Textarea rows={4} value={value} onChange={(e) => setValue(e.target.value)} /> : <p>{value}</p>}
            </div>
            <Separator orientation="horizontal" className="mb-2 mt-4" />
            <div className="flex items-start justify-between">
                <p className="text-sm text-gray-400">{formatDate(date)}</p>
                <div className="flex items-center gap-4">
                    <Button variant={enableEdit ? "default" : "secondary"} onClick={toggleEdit}>
                        {enableEdit ? "Save" : "Edit"}
                    </Button>
                    {enableEdit && (
                        <Button variant={"destructive"} onClick={toggleEdit}>
                            Cancel
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CorrectionMessage;
